import React, { useState } from 'react';
import { Menu, X, Smartphone } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleJoinWaitlist = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100 shadow-sm">
      <div className="container-max">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="/images/logo/logo-primary.png" 
              alt="Oralytics Logo" 
              className="h-8 w-auto"
            />
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-900 tracking-tight">Oralytics</span>
              <span className="text-xs text-gray-500 font-medium">AI Dental Health</span>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <a href="#home" className="text-gray-700 hover:text-oralytics-600 transition-colors font-medium">Home</a>
            <a href="#problem" className="text-gray-700 hover:text-oralytics-600 transition-colors font-medium">Problem</a>
            <a href="#solution" className="text-gray-700 hover:text-oralytics-600 transition-colors font-medium">Solution</a>
            <a href="#ai-models" className="text-gray-700 hover:text-oralytics-600 transition-colors font-medium">Results</a>
            <a href="#about" className="text-gray-700 hover:text-oralytics-600 transition-colors font-medium">About</a>
            <a href="#contact" className="text-gray-700 hover:text-oralytics-600 transition-colors font-medium">Contact</a>
            <button 
              onClick={handleJoinWaitlist}
              className="btn-primary shadow-lg hover:shadow-xl transition-all duration-200"
            >
              Join Waitlist
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-oralytics-600 p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
            <div className="px-4 pt-4 pb-6 space-y-2">
              <a href="#home" className="block px-4 py-3 text-gray-700 hover:text-oralytics-600 hover:bg-gray-50 rounded-lg transition-colors font-medium">Home</a>
              <a href="#problem" className="block px-4 py-3 text-gray-700 hover:text-oralytics-600 hover:bg-gray-50 rounded-lg transition-colors font-medium">Problem</a>
              <a href="#solution" className="block px-4 py-3 text-gray-700 hover:text-oralytics-600 hover:bg-gray-50 rounded-lg transition-colors font-medium">Solution</a>
              <a href="#ai-models" className="block px-4 py-3 text-gray-700 hover:text-oralytics-600 hover:bg-gray-50 rounded-lg transition-colors font-medium">Results</a>
              <a href="#about" className="block px-4 py-3 text-gray-700 hover:text-oralytics-600 hover:bg-gray-50 rounded-lg transition-colors font-medium">About</a>
              <a href="#contact" className="block px-4 py-3 text-gray-700 hover:text-oralytics-600 hover:bg-gray-50 rounded-lg transition-colors font-medium">Contact</a>
              <button 
                onClick={handleJoinWaitlist}
                className="w-full mt-4 btn-primary shadow-lg"
              >
                Join Waitlist
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 